import React from 'react';
import { Provider } from 'react-redux';
import { KendoLocalizationProvider } from '@contexts/kendo-localization-context';
import { KendoIntlProvider } from '@contexts/kendo-intl-context';
import { store } from './Redux/store';
import MapSchedulerContainer from './MapScheduler';
import { GlobalDragContextProvider } from './Contexts/GlobalDragContext';
import { ScheduleAndDispatchProvider } from './Contexts/ScheduleAndDispatchContext';
import { TenantContextProvider } from '../../contexts/tenant-context';
import { TimeZoneContextProvider } from '../../contexts/timezone-context';

function MapScheduler({
  selectOptions,
  assetsForSelect,
  configuration,
  permissions,
  timeZone,
  timeZonesForSelect,
  timeZonesMapping,
  fleetTracking
}) {
  return (
    <Provider store={store}>
      <KendoLocalizationProvider>
        <KendoIntlProvider>
          <TimeZoneContextProvider
            initialTimezone={timeZone}
            timeZonesForSelect={timeZonesForSelect}
            timeZonesMapping={timeZonesMapping}>
            <TenantContextProvider>
              <ScheduleAndDispatchProvider>
                <GlobalDragContextProvider>
                  <MapSchedulerContainer
                    selectOptions={selectOptions}
                    assetsForSelect={assetsForSelect}
                    configuration={configuration}
                    permissions={permissions}
                    fleetTracking={fleetTracking}
                  />
                </GlobalDragContextProvider>
              </ScheduleAndDispatchProvider>
            </TenantContextProvider>
          </TimeZoneContextProvider>
        </KendoIntlProvider>
      </KendoLocalizationProvider>
    </Provider>
  );
}
export default MapScheduler;
